import { useState, useEffect, useContext } from 'react';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import { LoadingDataRequestsType, SearchVehicleData } from '../types';
import styles from './SearchByLaximoVinContainer.module.scss';
import { SearchVehicleByVinDataContext } from '../SearchVehicleByVinDataProvider';

interface SpecificationProps {
	searchVehicle: SearchVehicleData;
	isMobile: boolean;
}

const Specification = ({ searchVehicle, isMobile }: SpecificationProps) => {
	const { findVehicle } = useContext(SearchVehicleByVinDataContext) as LoadingDataRequestsType;
	const [expanded, setExpanded] = useState(!isMobile);

	useEffect(() => {
		setExpanded(!isMobile);
	}, [isMobile]);

	return (
		<Accordion
			expanded={expanded}
			onChange={() => setExpanded(!expanded)}
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
			>
				<Typography variant="h6" style={{fontSize: 16}}>
					Оригинальная спецификация
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				<Table>
					<TableBody>
						{searchVehicle.headers.map(vehicleAttribute => (
							<TableRow className={styles.activeRow} key={vehicleAttribute.key}>
								<TableCell className={styles.headCell}>{vehicleAttribute.name}</TableCell>
								<TableCell 
									style={{padding: 5}} 
									className={styles.vehicleCell} 
									onClick={() => findVehicle(searchVehicle.vehicle)}
								>
									{vehicleAttribute.value}
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</AccordionDetails>
		</Accordion>
	);
};

export default Specification; 